import { FormControlLabel, Switch, SwitchProps } from '@mui/material';

export type ToggleProps = SwitchProps & {
  label?: string;
};

export const Toggle = ({ label, sx, ...props }: ToggleProps) => {
  return (
    <FormControlLabel
      control={<Switch disableFocusRipple disableRipple disableTouchRipple {...props} />}
      label={label}
      sx={{ marginRight: label ? 4 : 0, ...sx }}
    />
  );
};
